var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-col",
    { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
    [
      _vm.item.streamAble == true
        ? _c(
            "v-col",
            {
              staticClass: "thumbnail_box online ma-0 pa-0",
              staticStyle: { cursor: "pointer" },
              attrs: { cols: "12" },
              on: {
                click: function ($event) {
                  return _vm.goVideoPlayer()
                },
              },
            },
            [
              _vm.thumbnail != null
                ? _c("img", {
                    key: _vm.thumbnailKey,
                    staticClass: "ma-0 pa-0",
                    staticStyle: { height: "100%", width: "100%" },
                    attrs: { src: _vm.thumbnail },
                    on: {
                      load: function ($event) {
                        return _vm.onLoad(_vm.index)
                      },
                      error: function ($event) {
                        return _vm.thumbnailError(_vm.index, $event)
                      },
                    },
                  })
                : _vm._e(),
              _vm.streamingUrlLoading == false
                ? _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-0 pl-2",
                      attrs: {
                        cols: "12",
                        id: "thumbnail_title_box",
                        align: "left",
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.item.cameraName) + " ")]
                  )
                : _vm._e(),
              _vm.imgLoaders[_vm.index] == true
                ? _c("v-skeleton-loader", {
                    attrs: {
                      id: "img_skeleton",
                      width: "100%",
                      height: "100%",
                      boilerplate: false,
                      elevation: "0",
                      dark: "",
                      type: "image",
                    },
                  })
                : _vm.thumbnail === null
                ? _c("v-skeleton-loader", {
                    attrs: {
                      id: "img_skeleton",
                      width: "100%",
                      height: "100%",
                      boilerplate: false,
                      elevation: "0",
                      dark: "",
                      type: "image",
                    },
                  })
                : _vm._e(),
              _vm.thumbnail === null
                ? _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-0",
                      attrs: { id: "thumbnail_device_status" },
                    },
                    [
                      _c("v-col", { staticClass: "ma-0 pa-0" }, [
                        _vm._v(_vm._s(_vm.td("fetchingThumbnail"))),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _c(
            "v-col",
            {
              staticClass: "thumbnail_box ma-0 pa-0",
              staticStyle: { cursor: "pointer" },
              attrs: { cols: "12" },
              on: {
                click: function ($event) {
                  return _vm.noUrlGoVideoPlayer(_vm.index)
                },
              },
            },
            [
              _c("img", {
                staticClass: "ma-0 pa-0",
                staticStyle: { height: "100%", width: "100%" },
                attrs: { src: require("@/assets/images/grey_background.png") },
              }),
              _c(
                "v-col",
                {
                  staticClass: "ma-0 pa-0",
                  attrs: { id: "thumbnail_device_status" },
                },
                [
                  _c("v-col", { staticClass: "ma-0 pa-0" }, [
                    _vm._v(_vm._s(_vm.t("offline"))),
                  ]),
                ],
                1
              ),
              _vm.streamingUrlLoading == false
                ? _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-0 pl-2",
                      attrs: {
                        cols: "12",
                        id: "thumbnail_title_box",
                        align: "left",
                      },
                    },
                    [_vm._v(_vm._s(_vm.item.cameraName))]
                  )
                : _vm._e(),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }